module.exports = __webpack_public_path__ + "img/newFile.95edc0ff.svg";